import toWebpImage from '@src/utils/to-webp-image';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
const pageLocalesData = getPageLocalesData();
const LocalesData = pageLocalesData.mechaUnit;


const falconData = LocalesData.falcon;
const feijingData = LocalesData.feijing;
const baihongData = LocalesData.baihong;

// function Lang() {
//   if (getLanguageByPath() === 'zh-Hant') {
//     return 'tc';
//   } else {
//     return getLanguageByPath();
//   }
// }

/**
 *  特装机甲数据
 */
export const mechaData = {
  voiceTabCH: '中文',
  voiceTabEN: '英语',
  voiceTabJA: '日语',
  basicInfoTitle: '基础信息',
  roleExperSubTitle: '角色经历',
  driverVoiceTitle: '驾驶员语音',
  mechaStorySubTitle: '机体背景',
  //  矛隼
  falcon: {
    mechaName:toWebpImage(`${require('./images/falcon/'+getLanguageByPath()+'/warrior-name.png')}`),
    mechaImg:toWebpImage(require(`./images/falcon/structure.png`)),
    driverImg:toWebpImage(require(`./images/falcon/per.png`)),
    iconBadge:toWebpImage(require(`./images/falcon/icon-badge.png`)),
    maLogo:toWebpImage(require(`./images/falcon/ma-logo.png`)),
    driverName: falconData.driverName,
    driverType: falconData.driverType,
    driversSex: falconData.driversSex,
    driversBirthplace: falconData.driversBirthplace,
    driversStructure: falconData.driversStructure,
    driversRoleExperText:falconData.driversRoleExperText,
    mechaInfoType: falconData.mechaInfoType,
    mechaInfoNums: falconData.mechaInfoNums,
    mechaInfoHeadHigh: falconData.mechaInfoHeadHigh,
    mechaInfoEmptyWeight: falconData.mechaInfoEmptyWeight,
    mechaInfoTotal: falconData.mechaInfoTotal,
    mechaInfoStory:falconData.mechaInfoStory,
    manufacturerGruopCh:falconData.manufacturerGruopCh,
    video_link: 'https://static-www.mechabreak.cn/video/20231206/youxitese/youxitese02.mp4',
    cvCH: falconData.cvCH,
    cvEN: falconData.cvEN,
    cvJA: falconData.cvJA,
    zhCvList: [
      {
        cvAudio_url: 'https://static-omni-mechabreak.seasungames.cn/uploads/202505/mb_mecha_audio_1747732125138_falcon_ch01.wav',
        title:falconData.voice.title1,
        isPlay: false
      },
      {
        cvAudio_url: 'https://static-www.cbjq.com/audio/20231008/mauxir-cv.mp3',
        title:falconData.voice.title2,
        isPlay: false
      },
      {
        cvAudio_url: 'https://static-www.cbjq.com/audio/20231008/mauxir-cv.mp3',
        title:falconData.voice.title3,
        isPlay: false
      }
    ],
    enCvList: [
      {
        cvAudio_url: 'https://static-www.cbjq.com/audio/20231008/mauxir-cv.mp3',
        title: falconData.voice.title1,
        isPlay: false
      },
      {
        cvAudio_url: 'https://static-www.cbjq.com/audio/20231008/mauxir-cv.mp3',
        title: falconData.voice.title2,
        isPlay: false
      },
      {
        cvAudio_url: 'https://static-www.cbjq.com/audio/20231008/mauxir-cv.mp3',
        title:falconData.voice.title3,
        isPlay: false
      }
    ],
    jaCvList: [
      {
        cvAudio_url: 'https://static-www.cbjq.com/audio/20231008/mauxir-cv.mp3',
        title: falconData.voice.title1,
        isPlay: false
      },
      {
        cvAudio_url: 'https://static-www.cbjq.com/audio/20231008/mauxir-cv.mp3',
        title: falconData.voice.title2,
        isPlay: false
      },
      {
        cvAudio_url: 'https://static-www.cbjq.com/audio/20231008/mauxir-cv.mp3',
        title: falconData.voice.title3,
        isPlay: false
      }
    ]
  },
  // 飞景
  feijing: {
    mechaName:toWebpImage(`${require('./images/feijing/'+getLanguageByPath()+'/warrior-name.png')}`),
    mechaImg:toWebpImage(require(`./images/feijing/structure.png`)),
    driverImg:toWebpImage(require(`./images/feijing/per.png`)),
    iconBadge:toWebpImage(require(`./images/feijing/icon-badge.png`)),
    maLogo:toWebpImage(require(`./images/feijing/ma-logo.png`)),
    driverName: feijingData.driverName,
    driverType: feijingData.driverType,
    driversSex: feijingData.driversSex,
    driversBirthplace: feijingData.driversBirthplace,
    driversStructure: feijingData.driversStructure,
    driversRoleExperText:feijingData.driversRoleExperText,
    mechaInfoType: feijingData.mechaInfoType,
    mechaInfoNums: feijingData.mechaInfoNums,
    mechaInfoHeadHigh: feijingData.mechaInfoHeadHigh,
    mechaInfoEmptyWeight: feijingData.mechaInfoEmptyWeight,
    mechaInfoTotal: feijingData.mechaInfoTotal,
    mechaInfoStory:feijingData.mechaInfoStory,
    manufacturerGruopCh:feijingData.manufacturerGruopCh,
    video_link: 'https://static-www.mechabreak.cn/video/20231206/youxitese/youxitese02.mp4',
    cvCH: feijingData.cvCH,
    cvEN: feijingData.cvEN,
    cvJA: falconData.cvJA,
    zhCvList: [
      {
        cvAudio_url: 'https://static-www.cbjq.com/audio/20231008/mauxir-cv.mp3',
        title:feijingData.voice.title1,
        isPlay: false
      },
      {
        cvAudio_url: 'https://static-www.cbjq.com/audio/20231008/mauxir-cv.mp3',
        title:feijingData.voice.title2,
        isPlay: false
      },
      {
        cvAudio_url: 'https://static-www.cbjq.com/audio/20231008/mauxir-cv.mp3',
        title:feijingData.voice.title3,
        isPlay: false
      }
    ],
    enCvList: [
      {
        cvAudio_url: 'https://static-www.cbjq.com/audio/20231008/mauxir-cv.mp3',
        title: feijingData.voice.title1,
        isPlay: false
      },
      {
        cvAudio_url: 'https://static-www.cbjq.com/audio/20231008/mauxir-cv.mp3',
        title: feijingData.voice.title2,
        isPlay: false
      },
      {
        cvAudio_url: 'https://static-www.cbjq.com/audio/20231008/mauxir-cv.mp3',
        title:feijingData.voice.title3,
        isPlay: false
      }
    ],
    jaCvList: [
      {
        cvAudio_url: 'https://static-www.cbjq.com/audio/20231008/mauxir-cv.mp3',
        title: feijingData.voice.title1,
        isPlay: false
      },
      {
        cvAudio_url: 'https://static-www.cbjq.com/audio/20231008/mauxir-cv.mp3',
        title: feijingData.voice.title2,
        isPlay: false
      },
      {
        cvAudio_url: 'https://static-www.cbjq.com/audio/20231008/mauxir-cv.mp3',
        title: feijingData.voice.title3,
        isPlay: false
      }
    ]
  },
  // 白虹
  baihong: {
    mechaName:toWebpImage(`${require('./images/baihong/'+getLanguageByPath()+'/warrior-name.png')}`),
    mechaImg:toWebpImage(require(`./images/baihong/structure.png`)),
    driverImg:toWebpImage(require(`./images/baihong/per.png`)),
    iconBadge:toWebpImage(require(`./images/baihong/icon-badge.png`)),
    maLogo:toWebpImage(require(`./images/baihong/ma-logo.png`)),
    driverName: baihongData.driverName,
    driverType: baihongData.driverType,
    driversSex: baihongData.driversSex,
    driversBirthplace: baihongData.driversBirthplace,
    driversStructure: baihongData.driversStructure,
    driversRoleExperText:baihongData.driversRoleExperText,
    mechaInfoType: baihongData.mechaInfoType,
    mechaInfoNums: baihongData.mechaInfoNums,
    mechaInfoHeadHigh: baihongData.mechaInfoHeadHigh,
    mechaInfoEmptyWeight: baihongData.mechaInfoEmptyWeight,
    mechaInfoTotal: baihongData.mechaInfoTotal,
    mechaInfoStory:baihongData.mechaInfoStory,
    manufacturerGruopCh:baihongData.manufacturerGruopCh,
    video_link: 'https://static-www.mechabreak.cn/video/20231206/youxitese/youxitese02.mp4',
    cvCH: baihongData.cvCH,
    cvEN: baihongData.cvEN,
    cvJA: baihongData.cvJA,
    zhCvList: [
      {
        cvAudio_url: 'https://static-www.cbjq.com/audio/20231008/mauxir-cv.mp3',
        title:baihongData.voice.title1,
        isPlay: false
      },
      {
        cvAudio_url: 'https://static-www.cbjq.com/audio/20231008/mauxir-cv.mp3',
        title:baihongData.voice.title2,
        isPlay: false
      },
      {
        cvAudio_url: 'https://static-www.cbjq.com/audio/20231008/mauxir-cv.mp3',
        title:baihongData.voice.title3,
        isPlay: false
      }
    ],
    enCvList: [
      {
        cvAudio_url: 'https://static-www.cbjq.com/audio/20231008/mauxir-cv.mp3',
        title: baihongData.voice.title1,
        isPlay: false
      },
      {
        cvAudio_url: 'https://static-www.cbjq.com/audio/20231008/mauxir-cv.mp3',
        title: baihongData.voice.title2,
        isPlay: false
      },
      {
        cvAudio_url: 'https://static-www.cbjq.com/audio/20231008/mauxir-cv.mp3',
        title:baihongData.voice.title3,
        isPlay: false
      }
    ],
    jaCvList: [
      {
        cvAudio_url: 'https://static-www.cbjq.com/audio/20231008/mauxir-cv.mp3',
        title: baihongData.voice.title1,
        isPlay: false
      },
      {
        cvAudio_url: 'https://static-www.cbjq.com/audio/20231008/mauxir-cv.mp3',
        title: baihongData.voice.title2,
        isPlay: false
      },
      {
        cvAudio_url: 'https://static-www.cbjq.com/audio/20231008/mauxir-cv.mp3',
        title: baihongData.voice.title3,
        isPlay: false
      }
    ]
  }
};
